<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" :z-index="3000" :fullscreen="true">
      <v-card>
        <v-flex xs12>
          <!--v-card-title>{{translater.__('Edit Route Description')}}</v-card-title-->
          <v-card-text>
            <v-container class="text-xs-center" wrap>
              <v-flex xs12>
                <v-textarea
                  :label="translater.__('Description')"
                  :value="newDescription"
                  @keyup="setNewDescription($event)"
                ></v-textarea>

                <v-card v-for="(f, fi) in mFiles" :key="`file-${fi}`" v-if="f.remove === false">
                  <v-img
                    v-if="f.type == 'Image' && !f.replace"
                    :src="getImageSource(f)"
                    aspect-ratio="1"
                  ></v-img>
                  <Upload
                    v-if="f.type == 'Image' && f.replace === true"
                    upload="files/uploadRouteDescriptionImage"
                  ></Upload>
                  <v-card-text v-if="f.type == 'YoutubeVideo'">
                    <v-text-field :value="getYoutubeVideoPath(f)"></v-text-field>
                  </v-card-text>
                  <v-container>
                    <v-card-actions>
                      <v-btn flat color="error" @click="deleteDescriptionFile(fi)" small>
                        <v-icon>delete</v-icon>
                        {{translater.__('Delete')}}
                      </v-btn>
                      <v-btn
                        flat
                        small
                        :disabled="replace"
                        @click="setReplace(fi, true)"
                        v-if="f.type == 'Image' && f.replace === false"
                        color="primary"
                      >
                        <v-icon>backup</v-icon>
                        &nbsp;
                        {{translater.__('Upload', 'routes')}}
                      </v-btn>
                      <v-btn
                        flat
                        @click="setReplace(fi, false)"
                        v-if="f.type == 'Image' && f.replace === true"
                        color="primary"
                        small
                      >
                        <v-icon>cancel</v-icon>
                        &nbsp;
                        {{translater.__('Cancel')}}
                      </v-btn>
                    </v-card-actions>
                  </v-container>
                </v-card>

                <v-card>
                  <v-card-text>
                    <Upload
                      v-if="add === 'image'"
                      upload="files/uploadRouteDescriptionImage"
                      instruction-text="You can upload an image (png) file"
                      button-text="Upload image"
                    ></Upload>
                    <v-btn @click="add = undefined" v-if="add === 'image'" flat small color="error">
                      {{ translater.__('Cancel') }}
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <div v-if="add === 'youtube'">
                      <slot v-for="(nf, nfi) in newFiles">
                        <v-text-field
                          :key="`slot-text-${nfi}`"
                          :label="translater.__('Youtube Link', 'routes')"
                          @keyup="setNewFilePath($event, nfi)"
                          :value="nf.path"
                        ></v-text-field>
                        <div class="text-xs-left">
                          <v-btn @click="deleteNewFile(nfi)" flat small color="error">
                            <v-icon>delete</v-icon>
                            {{translater.__('Delete')}}
                          </v-btn>
                        </div>
                      </slot>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn flat small @click="addNewYoutubeVideo()" color="success">
                      <v-icon>add</v-icon>
                      {{translater.__('Add Youtube Video', 'routes')}}
                    </v-btn>
                    <v-btn flat small @click="uploadNewImage()" color="success">
                      <v-icon>add</v-icon>
                      {{translater.__('Upload Image', 'routes')}}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close()">{{translater.__('Close')}}</v-btn>
            <v-btn
              :disabled="!valid"
              color="blue darken-1"
              flat
              @click.native="setEditedRouteDescription()"
            >{{translater.__('Save')}}</v-btn>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Upload from "./Upload";
import { parseFileName } from "../../../tools";

export default {
  name: "EditRouteDescription",
  components: {
    Upload
  },

  data() {
    return {
      newDescription: "",
      mFiles: [],
      newFiles: [],
      replace: false,
      add: undefined
    };
  },

  methods: {
    deleteNewFile(nfi) {
      let files = this.newFiles;
      if (typeof files[nfi] !== "undefined") {
        files.splice(nfi, 1);
      }

      this.newFiles = files.slice();
    },

    parseFile(f) {
      return parseFileName(f);
    },

    setNewFilePath(event, i) {
      let links = this.newFiles;
      //links[i].path = event.target.value;

      this.$store
        .dispatch(
          "checkpointsValidator/validateYoutubeVideoTask",
          event.target.value
        )
        .then(validation => {
          links[i].path = event.target.value;
          links[i].valid = validation.valid;

          this.newFiles = links.slice();
        });
    },

    addNewYoutubeVideo() {
      this.add = "youtube";

      let links = this.newFiles;
      links.push({
        remove: false,
        path: undefined,
        type: "YoutubeVideo",
        valid: false
      });

      this.newFiles = [];
      this.newFiles = links;
    },

    uploadNewImage() {
      this.$store.commit("files/flushFilesToUpload");
      this.add = "image";
    },

    setNewDescription(event) {
      this.newDescription = event.target.value;
    },

    setEditedRouteDescription() {
      //console.log(this.newDescription, this.mFiles, this.newFiles)

      this.$store.dispatch("routes/updateDescription", {
        descriptionText: this.newDescription,
        files: this.mFiles.concat(this.newFiles)
      });
    },

    getImageSource(f) {
      let p = f.path;
      let lio = f.path.lastIndexOf("/") + 1;
      p = f.path.substring(lio);

      let path = this.fullPath + this.routeName + "/" + this.parseFile(p);

      return path;
    },

    getYoutubeVideoPath(f) {
      return "https://youtube.com/watch?v=" + f.path;
    },

    deleteDescriptionFile(i) {
      let files = this.mFiles;
      files[i].remove = true;
      this.mFiles = files;
    },

    setReplace(i, value) {
      this.$store.commit("files/flushFilesToUpload");
      this.replace = value;
      let files = this.mFiles;
      files[i].replace = value;
      this.mFiles = [];
      this.mFiles = files;
    },

    close() {
      //this.$store.commit('routes/flushEditableDescription');
      this.files.forEach((f, fi) => {
        if (
          typeof this.mFiles[fi] !== "undefined" &&
          typeof this.mFiles[fi].oldPath !== "undefined"
        ) {
          f.path = this.mFiles[fi].oldPath;
        }
      });
      this.dialog = false;
    }
  },

  created() {
    window.vm.$on("routeDescriptionImageUploaded", file => {
      if (this.replace) {
        let isBeingReplaced = this.mFiles.findIndex(f => {
          return f.replace === true;
        });

        if (isBeingReplaced > -1) {
          let files = this.mFiles;
          files[isBeingReplaced].path = "images/" + this.routeName + "/" + file;
          files[isBeingReplaced].replace = false;

          this.mFiles = [];
          this.mFiles = files;
        }

        this.replace = false;
      } else {
        let files = this.mFiles;
        files.push({
          remove: false,
          replace: false,
          valid: true,
          oldPath: "images/" + this.routeName + "/" + file,
          path: "images/" + this.routeName + "/" + file,
          type: "Image"
        });

        this.mFiles = [];
        this.mFiles = files;

        //console.log("####### adding new", this.mFiles)

        this.add = undefined;
      }
    });

    this.$nextTick(() => {
      document.getElementsByClassName(
        "v-dialog__content"
      )[0].style.zIndex = 3000;
    });
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.commit("files/flushFilesToUpload");
      this.newDescription = this.routeDescriptionText;
      this.mFiles = this.files.map(f => {
        //console.log("################f", f)

        f.remove = false;
        f.replace = false;
        f.oldPath = f.path;
        f.valid = true;

        return f;
      });
    });
  },

  computed: {
    files: {
      get() {
        let files = [];
        let route = this.$store.getters["routes/route"];
        if (
          typeof route !== "undefined" &&
          typeof route.routeDescription !== "undefined"
        ) {
          files = route.routeDescription.files;
        }

        /*let files =[ 
            {
                "type" : "Image",
                "path" : "images/test/pajulintu.png"
            }, 
            {
                "type" : "YoutubeVideo",
                "path" : "nSVvsYsMXn4"
            }
        ]*/

        return files;
      }
    },

    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    },

    dialog: {
      get() {
        return this.$store.getters["routes/editRouteDescription"];
      },

      set(value) {
        //console.log("taalla", value)
        this.$store.commit("routes/setEditRouteDescription", value);
      }
    },

    valid: {
      get() {
        let v = false;

        if (this.newDescription.trim() !== "") {
          let files = this.newFiles.concat(this.mFiles);
          let validFiles = files.filter(f => {
            return f.valid === true;
          });

          //console.log("files::", files);

          if (files.length === validFiles.length) {
            v = true;
          }
        }

        return v;
      }
    },

    routeName: {
      get() {
        return this.$store.getters["routes/route"].name;
      }
    },

    fullPath: {
      get() {
        let p = this.$store.getters["checkpoints/fullPaths"]["images"] + "/";

        return p;
      }
    },

    /*imageExists: {
				get()
				{
					
					return this.$store.getters['routes/editableDescription'].imageExists
				}
			}, */

    routeDescriptionText: {
      get() {
        let desc = this.$store.getters["routes/route"].routeDescription
          .descriptionText;

        return desc;
      }
    }

    /*path: {
				get()
				{
					let p = '';

					if(this.$store.getters['routes/editableDescription'].files.length == 1)
					{
						p = this.$store.getters['routes/editableDescription'].files[0].path;
					}

					return p;
				},

				set(value)
				{

					


					this.$store.commit('routes/setRouteDescriptionPath', value)
					this.$store.dispatch('routesValidator/validateDescription')
					
				}
			}, */

    /*fileType: {
				get()
				{
					

					
					let t = this.$store.getters['routes/editableDescription'].type;
					console.log("t", t)

					return t;
					
				},

				set(value)
				{
					



					this.$store.dispatch('routes/setRouteDescriptionType', value)
					this.$store.dispatch('routesValidator/validateDescription')
					
				}

			}, */

    /*replace: {
				get()
				{
					return this.$store.getters['routes/editableDescription'].replace;
				},

				set(value)
				{
					return this.$store.commit('routes/setDescriptionImageReplace', value)
				}
			} */
  }
};
</script>